import React from "react";
import { Button } from "@mui/material";

export default function PinkExtraSmallButton({
  startIcon,
  buttonTitle,
  onClick,
  disabled,
  endIcon,
  borderRadius
}) {
  return (
    <Button
      variant="contained"
      startIcon={startIcon ? startIcon : ""}
      onClick={onClick}
      disabled={disabled}
      endIcon={endIcon}
      sx={{
        borderRadius: borderRadius ? borderRadius : "6px",
        fontSize: "12px",
        height: "30px",
        fontFamily: "Inter",
        fontWeight: 700,
        textTransform: "none",
        backgroundColor: "#9D0385",
        px: 3,
        "&:hover": {
          backgroundColor: "#9D0385",
        },
      }}
    >
      {buttonTitle}
    </Button>
  );
}
